/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const RemoveBookmark = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 13 17">
      <g id="3.-View-results" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g
          id="View-results,-comments---bookmark-and-sentiment-analysis"
          transform="translate(-1215.000000, -638.000000)"
          stroke="#3D3D35"
          strokeWidth="1.3">
          <g id="Group-111" transform="translate(1143.000000, 628.000000)">
            <g id="Group-109" transform="translate(60.000000, 0.000000)">
              <g id="Bookmark_delete" transform="translate(12.000000, 10.000000)">
                <g id="Layer_1" transform="translate(0.000000, 3.000000)">
                  <polyline id="Path" points="10.79 6.52 10.79 13.4 5.65 8.91 0.66 13.56 0.65 0.38 4.74 0.38" />
                </g>
                <g id="Layer_2" transform="translate(6.000000, 0.000000)">
                  <circle id="Oval" fill="#FFFFFF" cx="4.25" cy="4.17" r="3.52" />
                  <path d="M3.04,4.17 L5.55,4.17" id="Path" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </BaseSvgIcon>
  )
}

export default RemoveBookmark
